
import { Component, EventEmitter, Input, Output, DoCheck } from '@angular/core';
import { TranslateService, TranslatePipe, LangChangeEvent } from '@ngx-translate/core';
import { GlobalVariables } from '../../../../../../../common/global-variables';

@Component({
  selector: 'ready-to-complete-create',
  styles: [require('../../../direct-connect.scss')],
  template: require('./rtoc-create.html'),
    providers: [
      TranslateService
  ]
})
export class ReadyToCompleteCreate {
  @Input() stepData: Object;
  @Input() stepId: number;
  @Input() createData: any;
  @Input() prevStepId: any;
  private orgList: JSON;
  private isTranslationready: boolean = true;
  private strDCIPRanges: string;
  private strGWIPRanges: string;

 constructor(private translate: TranslateService) {
    translate.use(GlobalVariables.LOCALE);
  }
  ngOnChanges(changes) {
    if (!this.stepData) {
        return;
    }

   if (this.stepData[0] && this.stepData[0].ipRanges) {
       let arrIPRanges = this.stepData[0].ipRanges.map(function(item){
            return item.startAddress + ' - ' + item.endAddress;
        });
        this.strDCIPRanges = arrIPRanges.join(', ');
    }

    if (this.stepData[2] && this.stepData[2].ipRanges) {
       let arrIPRanges = this.stepData[2].ipRanges.map(function(item){
            return item.startAddress + ' - ' + item.endAddress;
        });
        this.strGWIPRanges = arrIPRanges.join(', ');
    }

  }

   getIPRanges(ipRanges) {
      if (!ipRanges) {
          return '-';
      }
      let str = '';
      for (let i = 0; i < ipRanges.length; i++) {
          str += ipRanges[i].startAddress + " - " + ipRanges[i].endAddress + '<br />';
      }
      return str;
   }

}



// WEBPACK FOOTER //
// ./src/app/components/network/direct-connect/wizards/connect-gateway/steps/rtoc-create.component.ts